import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouteStopStore = defineStore('routeStops', () => {
  // --- UI State only ---
  const focusedStopId = ref<number | null>(null);
  const headerTitle = ref<string | null>(null);

  const clearFocusedStop = () => {
    focusedStopId.value = null;
  };

  const setFocusedStop = (id: string | number | null) => {
    if (id === null) {
      focusedStopId.value = null;
      return;
    }
    const stopId = typeof id === 'string' ? Number.parseInt(id, 10) : id;
    focusedStopId.value = Number.isFinite(stopId) ? stopId : null;
  };

  const setHeaderTitle = (title: string | null) => {
    headerTitle.value = title;
  };

  const clearHeaderTitle = () => {
    headerTitle.value = null;
  };

  return {
    focusedStopId,
    headerTitle,
    clearFocusedStop,
    clearHeaderTitle,
    setFocusedStop,
    setHeaderTitle,
  };
});
